<div class="pills-container">
  <pill 
    *ngFor="let value of pillsData" 
    [icon]="value.icon" 
    displayText="{{ value.name }}" />
  <a 
    [href]="profileLinkUrl" 
    target="_blank"
    class="profile-link-url" 
    *ngIf="matchedProviderSpecialties.length > 3">
    +{{ matchedProviderSpecialties.length - 3 }} more
  </a>
</div>